import {createSelector} from '@ngrx/store';
import {entityRotasFeatureKey, selectAll, selectEntities, StateRota} from './entity-rota.reducer';
import {EntityRota} from './entity-rota.model';
import {Map} from 'immutable';
import {selectors} from '~utils/ngrx-util';

const {
  entitySelectAll,
  entitySelectEntities,
  entitySelectById,
  selectEntityFeature,
} = selectors<EntityRota, StateRota>(entityRotasFeatureKey, {selectAll, selectEntities});

export const entityRotaSelectAll = entitySelectAll;
export const entityRotaSelectEntities = entitySelectEntities;
export const entityRotaSelectById = entitySelectById;

export const entityRotaSelectAtivas = createSelector(
  selectEntityFeature,
  ({entities, ids, loaded}) => ({
    rotasAtivas: (ids as string[]).filter(k => isAtivo(entities[k] as EntityRota)).map(k => entities[k]) as EntityRota[],
    loaded,
  })
);

export const entityRotaSelectCanceladas = createSelector(
  selectEntityFeature,
  ({entities, ids, loaded}) => ({
    rotasCanceladas: (ids as string[]).filter(k => isCancelado(entities[k] as EntityRota)).map(k => entities[k]) as EntityRota[],
    loaded,
  })
);

export const entityRotaSelectMap = createSelector(entityRotaSelectEntities, (entities) => Map(entities));

const isAtivo = (r: EntityRota) => !!r?.ativo && !r?.oculto;
const isCancelado = (r: EntityRota) => !r?.ativo && !r?.oculto;
